var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_639_07459"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_639_07459)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.75,23.75C3.75,23.75,26.25,23.75,26.25,23.75C26.25,23.75,26.25,26.25,26.25,26.25C26.25,26.25,3.75,26.25,3.75,26.25C3.75,26.25,3.75,23.75,3.75,23.75C3.75,23.75,3.75,23.75,3.75,23.75ZM16.25,16.465C16.25,16.465,23.8387,8.875,23.8387,8.875C23.8387,8.875,25.6063,10.6425,25.6063,10.6425C25.6063,10.6425,15,21.25,15,21.25C15,21.25,4.39375,10.64375,4.39375,10.64375C4.39375,10.64375,6.16125,8.875,6.16125,8.875C6.16125,8.875,13.75,16.4625,13.75,16.4625C13.75,16.4625,13.75,2.5,13.75,2.5C13.75,2.5,16.25,2.5,16.25,2.5C16.25,2.5,16.25,16.465,16.25,16.465C16.25,16.465,16.25,16.465,16.25,16.465Z",
    fill: "#27314D",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8e28a5a0ddebed4bd1a7f3dce0020909.svg";
export { ForwardRef as ReactComponent };